/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banners_Common_DismissInputs */

const de_banners_common_dismiss = /** @type {(inputs: Banners_Common_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

/** @type {(inputs: Banners_Common_DismissInputs) => LocalizedString} */
const en_banners_common_dismiss = de_banners_common_dismiss;

/**

* @param {Banners_Common_DismissInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const banners_common_dismiss = /** @type {((inputs?: Banners_Common_DismissInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banners_Common_DismissInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_banners_common_dismiss(inputs)
	return en_banners_common_dismiss(inputs)
});